import React, { useRef, useState } from 'react';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonModal, IonPage, IonRefresher, IonRefresherContent, IonRow, IonText, IonTitle, IonToolbar, RefresherCustomEvent, useIonAlert, useIonRouter, useIonViewWillEnter } from '@ionic/react';
import { timeOutline, pizzaOutline } from 'ionicons/icons';
// import ExploreContainer from '../components/ExploreContainer';
import './Home.css';
import { getTables } from '../../../entities/tables';
import QRCode from 'qrcode';
import { ordersDineIn } from '../../../entities/orders-dine-in';
import { Order } from '../../../entities/orders-dine-in/models/types';
import { OrderItemModal } from '../../../components/modals/OrderItemModal';
import { updateItemStatus } from '../../../entities/update-item-status';

import HeaderComponent from '../../../components/HeaderComponent';
import { ActiveOrdersSkeleton } from '../../../components/ActiveOrdersSkeleton';
const Home: React.FC = () => {
  const router = useIonRouter();
  const modal = useRef<HTMLIonModalElement>(null);
  const [isLoading, setLoading] = useState(true)
  const modalOrder = useRef<HTMLIonModalElement>(null);
  const [presentingElement, setPresentingElement] = useState<HTMLElement | null>(null);
  const [qrData, setQrData] = useState()
  const [qrCode, setQrCode] = useState<any>()
  const [tableNumber, setTableNumber] = useState<any>()
  const [tables, setTables] = useState<any>([])
  const [orderItem, setOrdersItems] = useState<Order[]|any>([])
  const [order, setOrder] = useState<any>()
  const [orderId, setOrdeId] = useState<any>()
  // const [selectedItem, setSelectedItem] = useState<OrderItem | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const tablesList = async () => {
    try {
      const res = await getTables()
      console.log("Tbale", res)
      setTables(res)
    } catch (error) {
      console.log(error)
    }
  }
  const orderDineInItems = async () => {
    try {
      const res = await ordersDineIn()
      if(res.statusCode===401){
        setOrdersItems([])
        router.push('/auth',"root", "replace")
        return
         
      }
      console.log("ORDER", res)
      setOrdersItems(res)
      console.log("ORDER", orderItem)
    } catch (error) {
      console.log("ERROR",error)
      //  if(error.statusCode===404){
      //   setOrdersItems([])
      //   router.push('/auth',"root", "replace")
      //   return
         
      // }

    }
  }

  const cardTable = (data: any) => {
    switch (data.status) {
      case 'paid':
        return (
          // <IonRow> 
          <IonCol size="6" key={data.id}>
            <IonCard className="table-card table-card--paid">
              <IonCardContent class='table-card-content'>
                <div className="table-title">СТОЛ №{data.tableNumber}</div>
                <div className="table-status table-status--green">
                  Оплачен
                </div>
                <IonButton expand="block" size="small" className="btn-orange bg-[#F2994A] rounded-lg" onClick={() => router.push(`/ordered-table/${data.id}`)}>
                  Войти в стол
                </IonButton>
                {/* <IonButton expand="block" size="small" className="btn-green bg-[#27AE60] rounded-lg">
                  Закрыть стол
                </IonButton> */}
              </IonCardContent>
            </IonCard>
          </IonCol>)
      // </IonRow>)
      case 'occupied':
        return (
          <IonCol size="6" key={data.id}>
            <IonCard className="table-card table-card--busy">
              <IonCardContent class='table-card-content'>
                <div className="table-title">СТОЛ №{data.tableNumber}</div>
                <div className="table-status table-status--orange">
                  <span className="dot dot--orange" />
                  Занят
                </div>
                {/* <div className="table-budget">Budget: 150.00 TJS</div> */}
                <IonButton expand="block" size="small" className="btn-orange bg-[#F2994A] rounded-lg" onClick={() => router.push(`/ordered-table/${data.id}`)}>
                  Войти в стол
                </IonButton>
              </IonCardContent>
            </IonCard>
          </IonCol>
        )
      default:
        return (
          <IonCol size="6" key={data.id}>
            <IonCard className="table-card table-card--free">
              <IonCardContent class='table-card-content'>
                <div className="table-title">СТОЛ №{data.tableNumber}</div>
                <div className="table-status">
                  <span className="dot dot--grey" />
                  Свободен
                </div>
                <IonButton onClick={() => showQr(data.qrCode, data.tableNumber)} expand="block" size="small" className='btn-dark !bg-[#333] rounded-lg'>
                  Показать QR
                </IonButton>
              </IonCardContent>
            </IonCard>
          </IonCol>
        )
    }
  }
  /** Номер стола для отображения: из заказа или по tableId из списка столов */
  const getOrderTableNumber = (order: { tableNumber?: string | null; tableId?: string | null }) => {
    if (order?.tableNumber) return order.tableNumber;
    if (order?.tableId && tables?.length) {
      const table = tables.find((t: { id: string }) => t.id === order.tableId);
      return table?.tableNumber ?? '—';
    }
    return '—';
  };

  const statusDish = (status: string, tableNumber: string) => {
    const tableLabel = tableNumber ? `Стол №${tableNumber}` : '—';
    switch (status) {
      case 'pending_confirmation':
        return <div className="order-card__status">
          <span className="dot dot--green" />
          <IonText >
            <span className={`text-[12px]  text-green-700   `}> Oжидает подтверждения</span> • {tableLabel}
          </IonText>
        </div>
      case 'preparing':
        return <div className="order-card__status">
          <span className="dot dot--orange" />
          <IonText >
            <span className={`text-[12px] text-orange-700  `}>Готовится</span> • {tableLabel}
          </IonText>
        </div>
      case 'ready':
        return <div className="order-card__status">
          <span className="dot dot--orange" />
          <IonText >
            <span className={`text-[12px] text-orange-700  `}>Готово</span> • {tableLabel}
          </IonText>
        </div>
      case 'served':
        return <div className="order-card__status">
          <span className="dot dot--blue" />
          <IonText >
            <span className={`text-sm text-blue-700 `}>Подано</span> • {tableLabel}
          </IonText>
        </div>
      case 'cancelled':
        return <div className="order-card__status">
          <span className="dot dot--red" />
          <IonText >
            <span className={`text-sm text-red-700 `}>Отменён</span> • {tableLabel}
          </IonText>
        </div>
      default:
        return <div className="order-card__status">
          <span className="dot dot--grey" />
          <IonText >
            <span className={`text-sm text-gray-700 `}>Недоступно</span> • {tableLabel}
          </IonText>
        </div>
    }
  }
  function dismiss() {
    modal.current?.dismiss();
  }

  async function canDismiss(data?: any, role?: string) {
    return role !== 'gesture';
  }
  function showQr(qrcode: any, number: any) {
    console.log(qrcode)
    setQrData(qrcode)
    setTableNumber(number)
    QRCode.toDataURL(
      qrcode,
      {
        width: 220,
        margin: 1,
      },
      (err, url) => {
        if (err) {
          console.error('QR error:', err);
          return;
        }
        setQrCode(url);
      }
    );
    modal.current?.present()
  }
  function handleRefresh(event: RefresherCustomEvent) {
    setTimeout(() => {
      tablesList()
      orderDineInItems()
      event.detail.complete();
    }, 2000);
  }
  const handleConfirm = async () => {
    if (!order) return;

    const data = {
      "menuItemId": order.menuItemId,
      "itemId": order.itemId,
      "status": order.status == 'preparing' ? 'ready' : order.status == 'ready' ? "served" : "preparing"
    }
    await updateItemStatus(orderId, data)
    orderDineInItems()
    // отправить запрос: подтвердить блюдо
    setIsOpen(false);
  };

  const handleReject = async () => {
    if (!order) return;
    const data = {
      "menuItemId": order.menuItemId,
      "itemId": order.itemId,
      "status": "cancelled"
    }
    await updateItemStatus(orderId, data)
    orderDineInItems()
    setIsOpen(false);
  };
  const loadAll = async () => {
    try {
      setLoading(true);
      await Promise.all([orderDineInItems(), tablesList()]);
    } finally {
      setLoading(false);
    }
  };

  useIonViewWillEnter(() => {
    loadAll();
  })
  return (
    <IonPage>
      <HeaderComponent />
      <IonContent fullscreen className="tables-page">
        {isLoading ? (
          <div className="p-3">
            <ActiveOrdersSkeleton count={10} />
          </div>
        ) : (
          <>
            <IonRefresher slot="fixed" pullFactor={0.5} pullMin={100} pullMax={200} onIonRefresh={handleRefresh} >
              <IonRefresherContent ></IonRefresherContent>
            </IonRefresher>
            <section className="section py-3 px-2">
              <h2 className="section-title">Активные заказы</h2>
              {orderItem?.length === 0 && <div className="bg-gray-200 h-20 w-full rounded-2xl flex items-center justify-center"><p>Нет активных заказов</p></div>}
              {
                orderItem?.map((el: any) => (
                  el.items?.map((item: any) =>
                    item.status !== "cancelled" && (
                      <IonCard key={item.itemId} className="order-card  mt-2 " onClick={() => { setOrder(item);setOrdeId(el.id); setIsOpen(true) }}>
                        <IonCardContent className="order-card__content">
                          <div className="order-card__left">
                            {statusDish(item.status, getOrderTableNumber(el))}

                            <div className="order-card__item">

                              <div>
                                <div className="order-card__title">{item.name}</div>
                                <div className="order-card__subtitle">{item.size} • x1</div>
                              </div>
                            </div>
                          </div>

                          <div className="order-card__right">
                            {item.status == 'preparing' &&
                              <div className="order-card__time">
                                <IonIcon icon={timeOutline} />
                                <span>~{item.remainingMinutes} мин</span>
                              </div>}
                            <div className="order-card__price">{item.price} TJS</div>
                            <button className="order-card__link">Перейти</button>
                          </div>
                        </IonCardContent>
                      </IonCard>
                    )
                  )
                ))

              }

            </section>

            <section className="section py-3 px-2">
              <h2 className="section-title">Столы</h2>
              {tables.length == 0 && <div className="bg-gray-200 h-20 w-full rounded-2xl flex items-center justify-center"><p>Нет столов</p></div>}
              <IonGrid className="tables-grid">
                <IonRow>
                  {tables.map((item: any) => cardTable(item))}
                </IonRow>
              </IonGrid>
            </section>
            {/* {orderItemModal(modalOrder,dismiss,order)} */}
            {order && (
              <OrderItemModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onConfirm={handleConfirm}
                onReject={handleReject}
                item={order}
              />
            )}
            <IonModal ref={modal} trigger="open-modal" canDismiss={canDismiss} presentingElement={presentingElement!} initialBreakpoint={0.65} breakpoints={[0.65]}>
              <IonHeader className="bg-red-600">
                <IonToolbar className="">
                  <IonTitle>СТОЛ №{tableNumber}</IonTitle>
                  <IonButtons slot="end">
                    <IonButton onClick={() => dismiss()}>Close</IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonContent className="ion-padding">
                <div className="h-full pt-[50px] ">
                  <img
                    src={qrCode}
                    alt="QR"
                    className="block mx-auto rounded-xl bg-white p-2"
                    style={{ width: 240, height: 240 }}
                  />
                </div>
              </IonContent>
            </IonModal>
          </>)}
      </IonContent>
    </IonPage>
  );
};



export default Home;
